module.exports = __webpack_public_path__ + "static/media/cyoa.ae4e4eef.JPG";